<template>
  <div>
    <b-card>
      <div class="mb-1">
        <div class="d-flex align-items-center justify-content-between mb-1">
          <h4 class="mb-0">
            {{$t('raw_materials')}} / {{$t('sidebar.material')}}
          </h4>

          <b-button
            v-b-modal.modal-material
            variant="primary"
          >
            <feather-icon
              icon="PlusIcon"
              size="16"
            />
            {{$t('add')}}
          </b-button>
        </div>
        <hr>

        <b-table
          class="border"
          :fields="fields"
          :items="items"
          responsive
          hover
          :empty-text="$t('empty_text')"
          show-empty
        >
          <template #head()="props">
            <span>{{ $t(props.label) }}</span>
          </template>

          <template #cell(actions)>
            <div class="d-flex align-items-center justify-content-center">
              <b-button
                size="sm"
                class="mt-50 mb-50"
                variant="warning"
              >
                <feather-icon
                  icon="EditIcon"
                  size="15"
                />
              </b-button>

              <b-button
                class="ml-50 mt-50 mb-50"
                size="sm"
                variant="danger"
              >
                <feather-icon
                  icon="TrashIcon"
                  size="15"
                />
              </b-button>
            </div>
          </template>
        </b-table>
      </div>
    </b-card>

    <b-card class="mt-5">
      <div class="d-flex align-items-center justify-content-between mb-1">
        <h4 class="mb-0">
          {{$t('sidebar.instrument')}}
        </h4>

        <b-button
          v-b-modal.modal-instrument
          variant="primary"
        >
          <feather-icon
            icon="PlusIcon"
            size="16"
          />
          {{$t('add')}}
        </b-button>
      </div>
      <hr>

      <b-table
        class="border"
        :fields="fieldsIns"
        :items="itemsIns"
        responsive
        hover
        :empty-text="$t('empty_text')"
        show-empty
      >
        <template #head()="props">
          <span>{{ $t(props.label) }}</span>
        </template>

        <template #cell(actions)>
          <div class="d-flex align-items-center justify-content-center">
            <b-button
              size="sm"
              class="mt-50 mb-50"
              variant="warning"
            >
              <feather-icon
                icon="EditIcon"
                size="15"
              />
            </b-button>

            <b-button
              class="ml-50 mt-50 mb-50"
              size="sm"
              variant="danger"
            >
              <feather-icon
                icon="TrashIcon"
                size="15"
              />
            </b-button>
          </div>
        </template>
      </b-table>
    </b-card>

    <b-card class="mt-5">
      <div class="d-flex align-items-center justify-content-between">
        <h4 class="mb-0">
          Куда и файл
        </h4>
      </div>
      <hr>

      <b-row class="mt-2">
        <b-col class="col-md-2">
          <b-form-group :label="$t('destination_warehouse')">
            <v-select
              class="bg-white rounded"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="first_name"
              :options="[]"
            />
          </b-form-group>
        </b-col>

        <b-col class="col-md-2">
          <b-form-group
            :label="$t('courses.file')"
          >
            <b-form-file
              v-model="moving.file"
              multiple
              :placeholder="$t('choose_file_or_drop')"
              @input="handleFileInput"
            />

            <div
              v-for="(item,index) in selectedFiles"
              :key="item.id"
              class="d-flex align-items-center justify-content-between mt-1"
            >
              <b-link class="text-decoration">
                <span v-if="moving.file">
                  {{ item.name }}
                </span>
              </b-link>

              <b-button
                class="p-50"
                size="sm"
                variant="danger"
                @click="handleDeleteFile(index)"
              >
                <feather-icon
                  icon="TrashIcon"
                />
              </b-button>
            </div>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>

    <div class="d-flex align-items-center justify-content-end">
      <b-button
        class="mr-1"
        variant="outline-secondary"
        @click="$router.push('/moving')"
      >
        {{ $t('cancel') }}
      </b-button>

      <b-button
        :variant="$route.params.id ? 'warning' : 'success'"
      >
        {{ $t('save') }}
      </b-button>
    </div>


  </div>
</template>

<script>
import {
  BCard,
  BTable,
  BButton,
  BFormFile,
  BRow,
  BCol,
  BFormGroup,
  BLink,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BCard,
    BTable,
    BButton,
    BFormFile,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BLink,
  },

  data() {
    return {



      // ===============  PRIMARY_DATA_SECTION START ===============
      fields: [
        {
          label: 'reference.name',
          key: 'title',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'view',
          key: 'vid',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'amount',
          key: 'count',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'СКЛАД ОТПРАВКИ',
          key: 'warehouse',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'actions',
          key: 'actions',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
      ],
      items: [
        {
          title: 'Drel',
          vid: 'Plastik',
          count: '12',
          warehouse: 'Sergeli',
        },
      ],
      moving: {
        file: [],
      },
      selectedFiles: [],
      fieldsIns: [
        {
          label: 'reference.categoriya',
          key: 'category',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'reference.name',
          key: 'title',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'model',
          key: 'model',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Состояние',
          key: 'sostan',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Склад отправки',
          key: 'warehouse',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'amount',
          key: 'count',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'actions',
          key: 'actions',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
      ],
      itemsIns: [
        {
          category: 'Instrument',
          title: 'Otverka',
          model: 'Samsung',
          sostan: 'b/y',
          warehouse: 'sergeli',
          count: 111,
        },
      ],
      // ===============  PRIMARY_DATA_SECTION END ===============




    }
  },

  methods: {




    // ===============  HANDLE_SECTION START ===============
    handleFileInput() {
      this.selectedFiles.push(...this.moving.file)
    },
    handleDeleteFile(fileKey) {
      this.moving.file.splice(fileKey, 1)
      this.selectedFiles.splice(fileKey, 1)
    },
    // ===============  HANDLE_SECTION END ===============





  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
